"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregisterTouchEvents = exports.registerTouchEvents = exports.wasRecentTouchEnd = void 0;
const types_1 = require("../../types");
const inputModeManager_1 = require("../managers/inputModeManager");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onTouchInput = (_) => {
    (0, inputModeManager_1.setInputMode)(types_1.DetailedInputMode.Touch, false);
};
// Ignore mouse events triggered within this duration (50ms actually) of touch end
const IGNORE_MOUSE_DURATION = 150;
let recentTouchEnd = false;
let recentTouchEndTimeoutId;
const wasRecentTouchEnd = () => recentTouchEnd;
exports.wasRecentTouchEnd = wasRecentTouchEnd;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onTouchEnd = (_) => {
    clearTimeout(recentTouchEndTimeoutId);
    recentTouchEnd = true;
    recentTouchEndTimeoutId = setTimeout(() => {
        recentTouchEnd = false;
    }, IGNORE_MOUSE_DURATION);
};
let touchEventsRegistered = false;
const registerTouchEvents = () => {
    if (touchEventsRegistered) {
        return;
    }
    document.addEventListener('touchstart', onTouchInput, { passive: false });
    document.addEventListener('touchend', onTouchEnd, { passive: false });
    touchEventsRegistered = true;
};
exports.registerTouchEvents = registerTouchEvents;
const unregisterTouchEvents = () => {
    if (!touchEventsRegistered) {
        return;
    }
    document.removeEventListener('touchstart', onTouchInput);
    document.removeEventListener('touchend', onTouchEnd);
    touchEventsRegistered = false;
};
exports.unregisterTouchEvents = unregisterTouchEvents;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG91Y2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9mb3VuZGF0aW9uL3RvdWNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCx1Q0FBMkQ7QUFDM0QsbUVBQTREO0FBRTVELDZEQUE2RDtBQUM3RCxNQUFNLFlBQVksR0FBRyxDQUFDLENBQWEsRUFBRSxFQUFFO0lBQ25DLElBQUEsK0JBQVksRUFBQyx5QkFBaUIsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDakQsQ0FBQyxDQUFDO0FBRUYsa0ZBQWtGO0FBQ2xGLE1BQU0scUJBQXFCLEdBQUcsR0FBRyxDQUFDO0FBQ2xDLElBQUksY0FBYyxHQUFHLEtBQUssQ0FBQztBQUMzQixJQUFJLHVCQUFrQyxDQUFDO0FBRWhDLE1BQU0saUJBQWlCLEdBQUcsR0FBRyxFQUFFLENBQUMsY0FBYyxDQUFDO0FBQXpDLFFBQUEsaUJBQWlCLHFCQUF3QjtBQUV0RCw2REFBNkQ7QUFDN0QsTUFBTSxVQUFVLEdBQUcsQ0FBQyxDQUFhLEVBQUUsRUFBRTtJQUNqQyxZQUFZLENBQUMsdUJBQXVCLENBQUMsQ0FBQztJQUV0QyxjQUFjLEdBQUcsSUFBSSxDQUFDO0lBRXRCLHVCQUF1QixHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7UUFDdEMsY0FBYyxHQUFHLEtBQUssQ0FBQztJQUMzQixDQUFDLEVBQUUscUJBQXFCLENBQUMsQ0FBQztBQUM5QixDQUFDLENBQUM7QUFFRixJQUFJLHFCQUFxQixHQUFHLEtBQUssQ0FBQztBQUUzQixNQUFNLG1CQUFtQixHQUFHLEdBQUcsRUFBRTtJQUNwQyxJQUFJLHFCQUFxQixFQUFFLENBQUM7UUFDeEIsT0FBTztJQUNYLENBQUM7SUFDRCxRQUFRLENBQUMsZ0JBQWdCLENBQUMsWUFBWSxFQUFFLFlBQVksRUFBRSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDO0lBQzFFLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxVQUFVLEVBQUUsVUFBVSxFQUFFLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFFdEUscUJBQXFCLEdBQUcsSUFBSSxDQUFDO0FBQ2pDLENBQUMsQ0FBQztBQVJXLFFBQUEsbUJBQW1CLHVCQVE5QjtBQUVLLE1BQU0scUJBQXFCLEdBQUcsR0FBRyxFQUFFO0lBQ3RDLElBQUksQ0FBQyxxQkFBcUIsRUFBRSxDQUFDO1FBQ3pCLE9BQU87SUFDWCxDQUFDO0lBQ0QsUUFBUSxDQUFDLG1CQUFtQixDQUFDLFlBQVksRUFBRSxZQUFZLENBQUMsQ0FBQztJQUN6RCxRQUFRLENBQUMsbUJBQW1CLENBQUMsVUFBVSxFQUFFLFVBQVUsQ0FBQyxDQUFDO0lBRXJELHFCQUFxQixHQUFHLEtBQUssQ0FBQztBQUNsQyxDQUFDLENBQUM7QUFSVyxRQUFBLHFCQUFxQix5QkFRaEMifQ==